import { motion } from "framer-motion";
import { Wrench, Cog, Building2, ArrowRight, Sparkles } from "lucide-react";

const PILLARS = [
  {
    Icon: Wrench,
    title: "Modificamos tu seguro actual",
    text:
      "Revisamos la póliza que ya tienes, detectamos los vacíos de cobertura y la ajustamos a cómo opera realmente tu empresa hoy.",
  },
  {
    Icon: Cog,
    title: "Diseñamos coberturas a medida",
    text:
      "Si tu riesgo no calza con un producto estándar, estructuramos una póliza nueva: cláusulas, deducibles y límites hechos para tu operación.",
  },
  {
    Icon: Building2,
    title: "Respaldo local e internacional",
    text:
      "Trabajamos con las principales aseguradoras del país y con reaseguradores internacionales para colocar riesgos grandes o poco comunes.",
  },
];

const scrollToForm = () =>
  document.getElementById("cotizar")?.scrollIntoView({ behavior: "smooth" });

export const Tailored = () => {
  return (
    <section
      id="a-medida"
      data-testid="tailored-section"
      className="scroll-mt-24 py-12 sm:scroll-mt-28 sm:py-16"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-brand-gold">
              <Sparkles className="h-4 w-4" /> Seguros a medida
            </p>
            <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-brand-ink">
              Seguros que se adaptan a cada operación.
            </h2>
            <p className="mt-4 text-base sm:text-lg text-gray-600">
              Ninguna planta, faena ni flota es igual a otra. Por eso no vendemos pólizas de
              catálogo: partimos de cómo funciona tu empresa y construimos la cobertura desde
              ahí.
            </p>
            <button
              type="button"
              onClick={scrollToForm}
              data-testid="tailored-cta"
              className="group mt-6 inline-flex h-12 items-center justify-center gap-2 rounded-full bg-brand-ink px-6 text-sm font-semibold text-white shadow-lg shadow-brand-ink/25 transition-all hover:-translate-y-0.5 hover:bg-brand-inkHover"
            >
              Diseñar mi seguro
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </button>
          </div>

          <div className="grid gap-4 lg:col-span-7">
            {PILLARS.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`tailored-pillar-${i}`}
                className="flex gap-4 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition-all hover:-translate-y-0.5 hover:border-brand-yellow/50 hover:shadow-lg hover:shadow-brand-ink/5 sm:p-6"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-yellow/15 text-brand-gold">
                  <p.Icon className="h-6 w-6" />
                </span>
                <div className="min-w-0">
                  <h3 className="font-display text-lg font-bold leading-tight text-brand-ink">
                    {p.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-gray-600">{p.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
